import { Component, ElementRef, HostBinding, Input, EventEmitter, Renderer2 } from "@angular/core";
import { defaultOptions } from "./options";

@Component({
  selector: "tooltip",
  templateUrl: "./tooltip.component.html",
  host: {
    class: "tooltip",
  },
  styleUrls: ["./tooltip.component.sass"],
})
export class TooltipComponent {
  events = new EventEmitter();

  @Input() data: any;

  @HostBinding("style.top") hostStyleTop!: string;
  @HostBinding("style.left") hostStyleLeft!: string;
  @HostBinding("style.transition") hostStyleTransition!: string;
  @HostBinding("class.tooltip-show") hostClassShow!: boolean;
  @HostBinding("class.tooltip-light") hostClassLight!: boolean;

  _show: boolean = false;
  options = defaultOptions;
  isThemeLight = defaultOptions.theme === "light";

  @Input() set show(value: boolean) {
    if (value) this.setPosition();

    this._show = this.hostClassShow = value;
  }
  get show(): boolean {
    return this._show;
  }

  get placement() {
    return defaultOptions.placement;
  }

  get element() {
    return this.data.element;
  }

  get elementPosition() {
    return this.data.elementPosition;
  }

  get value() {
    return this.data.value;
  }

  get tooltipOffset(): number {
    return Number(8);
  }

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this.setStyles();
  }

  setPosition(): void {
    if (this.setHostStyle(this.placement)) {
      this.setPlacementClass(this.placement);
      return;
    } else {
      const placements = ["top", "right", "bottom", "left"];

      for (const placement of placements) {
        if (this.setHostStyle(placement)) {
          this.setPlacementClass(placement);
          return;
        }
      }
    }
  }

  setPlacementClass(placement: string): void {
    this.renderer.addClass(this.elementRef.nativeElement, "tooltip-" + placement);
  }

  setHostStyle(placement: string): boolean {
    const isSvg = this.element instanceof SVGElement;
    const tooltip = this.elementRef.nativeElement;
    const isCustomPosition = !this.elementPosition.right;

    let elementHeight = isSvg ? this.element.getBoundingClientRect().height : this.element.offsetHeight;
    let elementWidth = isSvg ? this.element.getBoundingClientRect().width : this.element.offsetWidth;
    const tooltipHeight = tooltip.clientHeight;
    const tooltipWidth = tooltip.clientWidth;
    const scrollY = window.pageYOffset;

    if (isCustomPosition) {
      elementHeight = 0;
      elementWidth = 0;
    }

    let topStyle;
    let leftStyle;

    if (placement === "top") {
      topStyle = this.elementPosition.top + scrollY - (tooltipHeight + this.tooltipOffset);
    }

    if (placement === "bottom") {
      topStyle = this.elementPosition.top + scrollY + elementHeight + this.tooltipOffset;
    }

    if (placement === "top" || placement === "bottom") {
      leftStyle = this.elementPosition.left + elementWidth / 2 - tooltipWidth / 2;
    }

    if (placement === "left") {
      leftStyle = this.elementPosition.left - tooltipWidth - this.tooltipOffset;
    }

    if (placement === "right") {
      leftStyle = this.elementPosition.left + elementWidth + this.tooltipOffset;
    }

    if (placement === "left" || placement === "right") {
      topStyle = this.elementPosition.top + scrollY + elementHeight / 2 - tooltip.clientHeight / 2;
    }

    const topEdge = topStyle;
    const bottomEdge = topStyle + tooltipHeight;
    const leftEdge = leftStyle;
    const rightEdge = leftStyle + tooltipWidth;
    const bodyHeight = window.innerHeight + scrollY;
    const bodyWidth = document.body.clientWidth;

    if (topEdge < 0 || bottomEdge > bodyHeight || leftEdge < 0 || rightEdge > bodyWidth) {
      return false;
    }

    this.hostStyleTop = topStyle + "px";
    this.hostStyleLeft = leftStyle + "px";
    return true;
  }

  setAnimationDuration() {
    this.hostStyleTransition = "opacity " + 300 + "ms";
  }

  setStyles() {
    this.setAnimationDuration();

    this.hostClassLight = this.isThemeLight;
  }
}
